import { edit } from '@/store/module/club/action/edit.js';
import { getById } from '@/store/module/club/action/getById.js';
import { getByUserId } from '@/store/module/club/action/getByUserId.js';
import { register } from '@/store/module/club/action/register.js';

export const actions = {
	edit,
	getById,
	getByUserId,
	register
};
